import { Injectable, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { GridParameters, columnn, gridFilterSettings } from './gridParameters';
import { OdataUrlParametersService } from './odataUrlParameters.service';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';

import { SharingDataService } from '../../Services/sharing-data.service';
import { GridService } from './grid.service';
import { StatePersistService } from 'src/app/Services/statePersist.service';
import { ErrorHandlingService } from 'src/app/Services/errorHandling.service';

@Injectable({
  providedIn: 'root'
})

export class GridTableParametersService {

  resourceDefinition;
  Picklist;

  constructor(
    private odata: OdataUrlParametersService,
    private translateResourceDefinition: TranslateResourceDefinitionPipe,
    private toPicklist: ToPicklistPipe,
    private fromPicklist: FromPicklistPipe,
    public datepipe: DatePipe,
    private shareData: SharingDataService,
    public gridService: GridService,
    private statePersistService: StatePersistService,
    private errorHandlingService: ErrorHandlingService
    ) {
      this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
      this.shareData.currentPicklist.subscribe(data => this.Picklist = data);
    }

  dateMonthYearFilter(value, column , gridParameters, columns, paginator) {
    column.dateFromToFilter = [];
    column.dateMonthFilter = value;
    this.getData(false, true, gridParameters, columns, paginator);
  }

  getPaginatorIntl(paginatorIntl) {
    paginatorIntl.itemsPerPageLabel = this.translateResourceDefinition.transform("ItemsPerPage", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common");
    paginatorIntl.nextPageLabel = this.translateResourceDefinition.transform("NextPage", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common");
    paginatorIntl.previousPageLabel = this.translateResourceDefinition.transform("PreviousPage", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common");
  }

  fromToFilter(fromTo: string, value: string, previousFromToValues) {
    let newValues = [];
    if (fromTo == "from") {
      newValues.push(value);
      newValues.push(previousFromToValues[1])
    }
    if (fromTo == "to") {
      newValues.push(previousFromToValues[0])
      newValues.push(value);
    }
    return newValues
  }

  sort(column, columns : columnn[], gridParameters: GridParameters) {
    if(gridParameters.orderColumns.length < 5 || gridParameters.orderColumns.includes(column)){
      columns.forEach(element => {
        if(element.name == column)
        {
          if(element.orderByArrow == "") {
            element.orderByArrow = "up";
            gridParameters.orderColumnsArrow.push("up");
            gridParameters.orderColumns.push(column);
          } else if (element.orderByArrow == "up"){
            element.orderByArrow = "down";
            let index = gridParameters.orderColumns.indexOf(column);
            gridParameters.orderColumnsArrow[index] = "down";
          } else if (element.orderByArrow == "down"){
            element.orderByArrow = "";
            let index = gridParameters.orderColumns.indexOf(column);
            gridParameters.orderColumnsArrow.splice(index, 1);
            gridParameters.orderColumns.splice(index, 1);
          }
        }
      });
    } else {
      this.errorHandlingService.showInfo('', this.translateResourceDefinition.transform("MaximumSortItems", this.resourceDefinition, "KEY_NAME", "LONG_TEXT", "Common"));
    }
  }

  addSelectPicklist(columnName, column : columnn[], itemText) {
    column.forEach(element => {
      if (element.picklistTableName != null && columnName == element.name){
        let picklistItem = this.fromPicklist.transform(itemText, this.Picklist[element.picklistTableName]);
        if(!element.picklistSelectedItems.includes(picklistItem)){
          element.picklistSelectedItems.push(picklistItem);
        } else {
          element.picklistSelectedItems.splice(element.picklistSelectedItems.indexOf(picklistItem),1)
        }
      }
    });
  }

  dateChange(value, column , gridParameters, columns, paginator){
    column.dateMonthFilter=null;
    let newValues = [];
    if (value.type.toLowerCase() == "from") {
      newValues.push(value.value);
      newValues.push(column.dateFromToFilter[1])
    }
    if (value.type.toLowerCase() == "to") {
      newValues.push(column.dateFromToFilter[0])
      newValues.push(value.value);
    }
    column.dateFromToFilter = newValues;
    this.getData(false, true, gridParameters, columns, paginator);
  }

  isCheckedPicklist(column : columnn, itemText: string){
    let picklistItem = "";
    var picklistTable = this.Picklist[column.picklistTableName];
    picklistTable.forEach(element => {
      if(itemText == element.text){
          picklistItem =  element.key;
      }
    });
    if(column.picklistSelectedItems.includes(picklistItem)){
      return true;
    }
    return false;
  }

  click(event) {
    event.stopPropagation();
  }

  onPaginateChange(pageInfo, newData, newGroup, dataLength, gridParameters) {
    gridParameters.pageInfo = pageInfo;
    if ((pageInfo.pageIndex + 1) * (pageInfo.pageSize) > newData.length - (newGroup / 2) &&
      (newData.length < dataLength || dataLength == 0)) {
      return true;
    }
    return false;
  }

  setTopAndSkip(newGroup: boolean, newDataLength: number, gridParameters : GridParameters) {
    if (newGroup) {
      gridParameters.skip = newDataLength;
      gridParameters.top = gridParameters.newGroupAmount;
    } else {
      if (newDataLength > gridParameters.newGroupAmount) {
        gridParameters.top = newDataLength;
      } else {
        gridParameters.top = gridParameters.newGroupAmount;
      }
      gridParameters.skip = 0;
    }
    return gridParameters;
  }

  getParameters(gridParameters: GridParameters, columns){
    gridParameters.order = this.odata.orderFilter(gridParameters.orderColumns, gridParameters.orderColumnsArrow);

    gridParameters.filter = "" + gridParameters.defaultFilter;

    columns.forEach(element => {
      if(element.fromToFilter){
        gridParameters.filter = this.odata.fromToFilter(element.name, element.fromToFilterValues, gridParameters.filter);
      }

      if(element.type == "picklist" || element.type == "picklistText" || element.type == "checkbox" || element.type == "checkboxText") {
        gridParameters.filter = this.odata.selectionFilter(element, gridParameters.filter);
      }

      if(element.type == "date"){
        gridParameters.filter = this.odata.dateFilter(element.name, element.dateFromToFilter, gridParameters.filter);
        gridParameters.filter = this.odata.dateMonthFilter(element.name, element.dateMonthFilter, gridParameters.filter);
      }

      if(element.columnSearch){
        gridParameters.filter = this.odata.search(element.name, element.search, gridParameters.filter)
      }

      if(element.defaultTextFilter != null){
        gridParameters.filter = this.odata.equalToString(element.name, element.defaultTextFilter, gridParameters.filter)
      }

      if(element.defaultNumberFilter != null){
        gridParameters.filter = this.odata.equalToNumber(element.name, element.defaultNumberFilter, gridParameters.filter)
      }

    });

    // var filter = `&$filter=(REQUESTOR eq '${User.USERGUID}' OR PERSON_ID eq '${User.USERGUID}')`
    // if(gridParameters.filter != "") {
    //   filter += ` AND ${gridParameters.filter}`;
    // }

    var filter = ``;
    if(gridParameters.filter != "") {
      filter += `&$filter=${gridParameters.filter}`;
    }


    return gridParameters.table + "?$count=true&$top=" + gridParameters.top + "&$skip=" + gridParameters.skip + gridParameters.order + filter;
  }


  clearFilters(columns : any, gridParameters : GridParameters){
    columns.forEach(column => {
      column.orderByArrow = "";
      column.dateFromToFilter = [null, null];
      column.dateMonthFilter = null;
      column.fromToFilterValues = ["",""];
      column.search = "";
      column.picklistSelectedItems = [];
    });
    gridParameters.orderColumnsArrow = [];
    gridParameters.orderColumns = [];
    gridParameters.selectedMultiRows = [];
    gridParameters.selectedSingleRows = "";
  }

  getData(newGroup:boolean, execute:boolean, gridParameters, columns, paginator){
    if(execute){
      gridParameters.displayedColumns = [];
      columns.forEach(element => {
        if(element.visible == true){
        gridParameters.displayedColumns.push(element.name);
        }
      });
      gridParameters = this.setTopAndSkip(newGroup,gridParameters.newData.length, gridParameters);
      gridParameters.parameterUrlNew = this.getParameters(gridParameters, columns);

      if(gridParameters.parameterUrlNew != gridParameters.parameterUrlOld && gridParameters.canGetData)
      {
        gridParameters.parameterUrlActual = gridParameters.parameterUrlNew;
        gridParameters.canGetData = false;
        gridParameters.showLoading = true;
        this.gridService.getGridData([gridParameters.parameterUrlActual], (data) => {
          if(gridParameters.parameterUrlNew === gridParameters.parameterUrlActual){
              this.writeResponseData(data[0], newGroup, gridParameters, paginator)
              gridParameters.parameterUrlOld = gridParameters.parameterUrlActual;
              gridParameters.canGetData = true;
            } else {
              gridParameters.canGetData = true;
              this.getData(false, true, gridParameters, columns, paginator)
            }
          var settings = new gridFilterSettings(columns, gridParameters);
          this.statePersistService.set(settings, gridParameters.table);
          gridParameters.selectedRows = [];
          gridParameters.showLoading = false;
        })
      }
    } else {
      var settings = new gridFilterSettings(columns, gridParameters);
      this.statePersistService.set(settings, gridParameters.table);
    }
  }

  writeResponseData(res, newGroup, gridParameters : GridParameters, paginator) {
    if (newGroup) {
      res.value.forEach(element => {
        gridParameters.newData.push(element);
      });
    } else {
      gridParameters.newData = res.value;
    }
    let data = [...gridParameters.newData];
    gridParameters.dataSource = new MatTableDataSource(data);
    gridParameters.dataLength = res['@odata.count'];
    gridParameters.dataSource.data.length = gridParameters.dataLength;
    gridParameters.dataSource.paginator = paginator;
    if(gridParameters.newData.length > 0){
      gridParameters.isSomeDada = true;
    }

    return gridParameters;
  }

  addSelectMulti(element, gridParameters : GridParameters){
    if(!gridParameters.selectedMultiRows.includes(element)){
      gridParameters.selectedMultiRows.push(element);
    } else {
      gridParameters.selectedMultiRows.splice(gridParameters.selectedMultiRows.indexOf(element),1);
    }
  }

  addSelectSingle(element, gridParameters : GridParameters){
    if(gridParameters.selectedSingleRows != element[gridParameters.selectedKey]){
      gridParameters.selectedSingleRows = element[gridParameters.selectedKey];
    } else {
      gridParameters.selectedSingleRows = null;
    }
  }

  isCheckedSingle(element, gridParameters: GridParameters){
    if(gridParameters.selectedSingleRows === element[gridParameters.selectedKey]){
      return true;
    }
    return false;
  }

  isCheckedMulti(element, gridParameters : GridParameters){
    // console.error(element)
    // // console.log(gridParameters.selectedMultiRows)
    // var count;
    // gridParameters.selectedMultiRows.forEach(selectedElement => {
    //   if(JSON.stringify(selectedElement) === JSON.stringify(element)){
        
    //     // console.log(true)
    //     // return true;
    //     count ++;
    //   }
    // });
    // if(count > 0){
    //   console.log(element)
    //   return true;
    // } else {
    //   return false;
    // }
    if(gridParameters.selectedMultiRows.includes(element)){
      // console.log(element)
      return true;
    }
    return false;
  }

  isIndeterminate(gridParameters : GridParameters){
    for(let i = gridParameters.pageInfo.pageIndex * gridParameters.pageInfo.pageSize; i< (gridParameters.pageInfo.pageIndex+1) * gridParameters.pageInfo.pageSize; i++){
      if(gridParameters.selectedMultiRows.includes(gridParameters.newData[i])) {
        return true;
      }
    }
    return false;
  }

  isAllSelected(gridParameters : GridParameters){
    for(let i = gridParameters.pageInfo.pageIndex * gridParameters.pageInfo.pageSize; i< (gridParameters.pageInfo.pageIndex+1) * gridParameters.pageInfo.pageSize; i++){
      if(!gridParameters.selectedMultiRows.includes(gridParameters.newData[i])) {
        return false;
      }
    }
    return true;
  }

  masterToggle(gridParameters : GridParameters){
    if(this.isAllSelected(gridParameters)){
    for(let i = gridParameters.pageInfo.pageIndex * gridParameters.pageInfo.pageSize; i< (gridParameters.pageInfo.pageIndex+1) * gridParameters.pageInfo.pageSize; i++){
        gridParameters.selectedMultiRows.splice(gridParameters.selectedMultiRows.indexOf(gridParameters.newData[i]),1);
      }
    } else {
      for(let i = gridParameters.pageInfo.pageIndex * gridParameters.pageInfo.pageSize; i< (gridParameters.pageInfo.pageIndex+1) * gridParameters.pageInfo.pageSize; i++){
        if(!gridParameters.selectedMultiRows.includes(gridParameters.newData[i])) {
          gridParameters.selectedMultiRows.push(gridParameters.newData[i]);
        }
      }
    }
  }

  exportAsXLSX(gridParameters : GridParameters, columns, groupName: string){
    let exportObject = [];
    let exportGridParameters = gridParameters;
    exportGridParameters.top = gridParameters.dataLength;
    exportGridParameters.skip = 0;
    this.gridService.getGridData([this.getParameters(exportGridParameters, columns)], (data) => {
      gridParameters.exportData = data[0].value;
      gridParameters.exportData.forEach(element => {
        let object = {};
        columns.forEach(columnElement => {
          if(columnElement.export){
            if(columnElement.picklistTableName != null){
              element[columnElement.name] = this.toPicklist.transform(element[columnElement.name], this.Picklist[columnElement.picklistTableName]);
            }
            if(columnElement.type == "date"){
              element[columnElement.name] = this.datepipe.transform(new Date(element[columnElement.name]), columnElement.format);
            }
            let newColumnName = this.translateResourceDefinition.transform(columnElement.name, this.resourceDefinition, "KEY_NAME", "LONG_TEXT", groupName);
            element[newColumnName] = element[columnElement.name];
            object[newColumnName] = element[columnElement.name];
            delete element[columnElement.name];
          } else {
            delete element[element.name];
          }
        });
        exportObject.push(object)
      });

      var json = exportObject;
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const excelData: Blob = new Blob([excelBuffer], {});
      FileSaver.saveAs(excelData,  "DBYD_" + gridParameters.exportToExcelName + ".xlsx");
    })
  }
}
